export default __webpack_public_path__ + "assets/error.929f4c7dd3afbb47d733f7822112ef64.svg";